import { Component, Inject } from '@angular/core';

import { NgForm } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { Preferences } from 'app/providers/bridge-api/preferences.service';
import { SemantriaConfiguration } from 'app/providers/semantria-api/configuration.service';
import { Analysis } from 'app/providers/storage-api/analysis.service';
import {
  injectComponentTelemetryService,
  EnableComponentTelemetry,
  EnableClassTelemetry,
} from 'app/services/otel.service';
import { ProjectCollection } from '../../models/project-collection.model';

export interface ReAnalyzeModalComponentOptions {
  groupConfigurations: SemantriaConfiguration[];
  preferences: Preferences;
  collection: ProjectCollection;
  projectId: string;
  analysis: Analysis;
  groupId: string;
}

@EnableClassTelemetry()
@Component({
  selector: 'app-reanalyze-modal',
  templateUrl: './reanalyze-modal.component.html',
  styleUrls: ['./reanalyze-modal.component.scss'],
  standalone: false,
})
export class ReAnalyzeModalComponent {
  @EnableComponentTelemetry() otelService = injectComponentTelemetryService();
  public configuration: string;

  public preferences: Preferences;
  public languages: string[] = [];
  public keyword: string;
  public selectedConfiguration = null;
  public selectedRouteLanguage = null;
  public configCount = 0;
  public collection: ProjectCollection;
  public analysisList: Analysis[];
  public projectId: string;
  public lastConfigId: string;
  public lastConfig: SemantriaConfiguration;

  analysis: Analysis;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ReAnalyzeModalComponentOptions,
    private dialogRef: MatDialogRef<ReAnalyzeModalComponent>
  ) {
    this.collection = data.collection;
    this.analysisList = this.collection.analyses;
    this.projectId = data.projectId;
    this.analysis = data.analysis;
  }

  public cancel(): void {
    this.dialogRef.close(false);
  }

  public get configRouteSelected() {
    return this.selectedConfiguration && this.selectedConfiguration.isConfigurationRoute
      ? this.selectedConfiguration.isConfigurationRoute
      : false;
  }

  public displayConfiguration(config?: SemantriaConfiguration): string | undefined {
    return config ? config.name : undefined;
  }

  public canSaveAnalysis(form: NgForm): boolean {
    return !(form.invalid || !this.configurationFieldValid || this.missingRouteLanguage);
  }

  private get missingRouteLanguage() {
    if (this.selectedConfiguration && this.selectedConfiguration.isConfigurationRoute) {
      if (!this.selectedRouteLanguage) {
        return true;
      }
    }
    return false;
  }

  public closeAndAnalyse() {
    const response: any = {};
    response.isIndustryPack = !!this.selectedConfiguration.isIndustryPack;
    response.isLanguageTemplate = !!this.selectedConfiguration.isLanguageTemplate;
    response.isConfigurationRoute = !!this.selectedConfiguration.isConfigurationRoute;
    response.configurationId = this.selectedConfiguration.id;
    if (response.isIndustryPack) {
      response.configurationId = 'ip:' + this.selectedConfiguration.id;
    }
    if (response.isLanguageTemplate) {
      response.configurationId = 'lt:' + this.selectedConfiguration.id;
    }
    if (response.isConfigurationRoute) {
      response.configurationId = 'cr:' + this.selectedConfiguration.route_id;
      if (this.selectedRouteLanguage && this.selectedRouteLanguage !== 'auto') {
        response.configurationId = response.configurationId + ':' + this.selectedRouteLanguage;
      }
    }
    this.dialogRef.close(response);
  }

  public get configurationFieldValid() {
    if (this.selectedConfiguration) {
      return true;
    }
    return false;
  }
}
